import getOptions from './options';
const rooms = [
  {
    "id": "CA1A",
    "selection": "Choose this apartment",
    "selectionActive": "Selected apartment",
    "title": "Studio pour 2 personnes",
    "features": {
      "people": "2",
      "area": "22m2",
      "city": "City view",
      "accessible": "Accessible",
      "kingBed": "Kingsize bed",
    },
    "from": "A partir de",
    "availableText": "",
    "images": [],
    "firstImage": [],
    "price": "\u00a3314",
    "priceCent": "16",
    "oldPrice": "\u00a3349.06",
    "popup": {
      "fullDescription": "S\u00e9jour avec un lit armoire double, cuisine \u00e9quip\u00e9e, salle de bains avec baignoire et WC, t\u00e9l\u00e9vision, t\u00e9l\u00e9phone, coffre-fort individuel, climatisation, wifi fibre optique , s\u00e9che cheveux.",
      "images": []
    },
    "discount": "Tarif membre -10%",
    "roomRates": [
      {
        "id": "LSTAY2-DR",
        "title": "TARIF FLEXIBLE SPECIAL- LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -45% en restant 28 nuits ou plus ! R\u00e9servez en toute tranquillit\u00e9, votre s\u00e9jour est modifiable et annulable sans frais.",
        "price": "\u00a3314",
        "priceCent": "16",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation soumise \u00e0 conditions",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "LSTAY2",
        "oldPrice": "\u00a3349.06",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a334.91 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - LSTAY2-DR"
          }
        }
      },
      {
        "id": "RA3AD4",
        "title": "TARIF PREPAYE - SPECIAL LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez de notre meilleur tarif !",
        "price": "\u00a3433",
        "priceCent": "32",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RA3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RA3AD4"
          }
        }
      },
      {
        "id": "1RA1-DR",
        "title": "TARIF FLEXIBLE",
        "subTitle": "B\u00e9n\u00e9ficiez de l\u0027offre la plus flexible, un tarif modifiable et annulable sans frais.",
        "price": "\u00a3449",
        "priceCent": "57",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "07 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RA1",
        "oldPrice": "\u00a3499.52",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a349.95 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RA1-DR"
          }
        }
      },
      {
        "id": "RB3AD4",
        "title": "TARIF BED \u0026 BREAKFAST PREPAYE - LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027 \u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez du meilleur prix sur votre h\u00e9bergement avec petit d\u00e9jeuner \u00e0 prix r\u00e9duit.",
        "price": "\u00a3529",
        "priceCent": "61",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Non remboursable",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RB3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RB3AD4"
          }
        }
      },
      {
        "id": "1RB1",
        "title": "TARIF FLEXIBLE - CHAMBRE ET PETIT D\u00c9JEUNER",
        "subTitle": "Profitez de notre tarif le plus flexible, petit d\u00e9jeuner compris. Aucun frais de modification ou d\u0027annulation.",
        "price": "\u00a3595",
        "priceCent": "82",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "06 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RB1",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RB1"
          }
        }
      }
    ],
    "filterString": "Pour 4 nuits | 2 adultes et enfants",
    "filterStringVariation": "4 nuits | starting from",
    "eventTracking": {
      "title": {
        "event": "GAevent",
        "eventCategory": "Booking funnel - Rates",
        "eventAction": "Rates - Click on CTA",
        "eventLabel": "Select room - CA1A"
      }
    }
  },
  {
    "id": "CA2B",
    "selection": "Choose this apartment",
    "selectionActive": "Selected apartment",
    "title": "Studio pour 2 personnes - Vue sur la Tour Eiffel",
    "features": {
      "people": "1",
      "area": "22m2",
      "pool": "Swimmingpool view",
      "accessible": "Accessible"
    },
    "from": "A partir de",
    "availableText": "",
    "images": [],
    "firstImage": [],
    "price": "\u00a3376",
    "priceCent": "45",
    "oldPrice": "\u00a3418.27",
    "popup": {
      "fullDescription": "Vivez votre exp\u00e9rience parisienne dans ce studio offrant une vue imprenable sur la Tour Eiffel.  La cuisine est tout \u00e9quip\u00e9e (avec lave-vaisselle) pour pr\u00e9parer de bons repas en toute autonomie.",
      "images": []
    },
    "discount": "Tarif membre -10%",
    "roomRates": [
      {
        "id": "LSTAY2-DR",
        "title": "TARIF FLEXIBLE SPECIAL- LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -45% en restant 28 nuits ou plus ! R\u00e9servez en toute tranquillit\u00e9, votre s\u00e9jour est modifiable et annulable sans frais.",
        "price": "\u00a3376",
        "priceCent": "45",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation soumise \u00e0 conditions",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "LSTAY2",
        "oldPrice": "\u00a3418.27",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a341.83 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - LSTAY2-DR"
          }
        }
      },
      {
        "id": "RA3AD4",
        "title": "TARIF PREPAYE - SPECIAL LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez de notre meilleur tarif !",
        "price": "\u00a3520",
        "priceCent": "59",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RA3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RA3AD4"
          }
        }
      },
      {
        "id": "1RA1-DR",
        "title": "TARIF FLEXIBLE",
        "subTitle": "B\u00e9n\u00e9ficiez de l\u0027offre la plus flexible, un tarif modifiable et annulable sans frais.",
        "price": "\u00a3538",
        "priceCent": "94",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "07 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RA1",
        "oldPrice": "\u00a3598.83",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a359.88 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RA1-DR"
          }
        }
      },
      {
        "id": "RB3AD4",
        "title": "TARIF BED \u0026 BREAKFAST PREPAYE - LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027 \u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez du meilleur prix sur votre h\u00e9bergement avec petit d\u00e9jeuner \u00e0 prix r\u00e9duit.",
        "price": "\u00a3616",
        "priceCent": "88",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Non remboursable",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RB3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RB3AD4"
          }
        }
      },
      {
        "id": "1RB1",
        "title": "TARIF FLEXIBLE - CHAMBRE ET PETIT D\u00c9JEUNER",
        "subTitle": "Profitez de notre tarif le plus flexible, petit d\u00e9jeuner compris. Aucun frais de modification ou d\u0027annulation.",
        "price": "\u00a3695",
        "priceCent": "12",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "06 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RB1",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RB1"
          }
        }
      }
    ],
    "filterString": "Pour 4 nuits | 2 adultes et enfants",
    "filterStringVariation": "4 nuits | starting from",
    "eventTracking": {
      "title": {
        "event": "GAevent",
        "eventCategory": "Booking funnel - Rates",
        "eventAction": "Rates - Click on CTA",
        "eventLabel": "Select room - CA2B"
      }
    }
  },
  {
    "id": "AR4P",
    "selection": "Choose this apartment",
    "selectionActive": "Selected apartment",
    "title": "Appartement 1 Chambre pour 4 personnes",
    "features": {
      "people": "x4",
      "area": "43m2"
    },
    "from": "A partir de",
    "availableText": "",
    "images": [],
    "firstImage": {
      "title": "Appartement 1 Chambre pour 4 personnes",
      "src": "https:\/\/medias.adagio-city.com\/photos\/6790_roar4p_00_p_346x260.jpg?twic=v1\/cover=307x230",
      "width": "307",
      "height": "230"
    },
    "price": "\u00a3441",
    "priceCent": "45",
    "oldPrice": "\u00a3490.50",
    "popup": {
      "fullDescription": "Appartement de 40m\u00b2 comprenant un s\u00e9jour avec 1 canap\u00e9 lit double, chambre avec 2 lits simples ou 1 lit double, cuisine \u00e9quip\u00e9e, salle de bains avec baignoire, WC, t\u00e9l\u00e9vision, t\u00e9l\u00e9phone, coffre-fort individuel, climatisation, wifi fibre optique.",
      "images": [
        {
          "title": "Appartement 1 Chambre pour 4 personnes",
          "src": "https:\/\/medias.adagio-city.com\/photos\/6790_roar4p_00_p_1024x768.jpg?twic=v1\/cover=720x540",
          "width": "720",
          "height": "540"
        }
      ]
    },
    "discount": "Tarif membre -10%",
    "roomRates": [
      {
        "id": "LSTAY2-DR",
        "title": "TARIF FLEXIBLE SPECIAL- LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -45% en restant 28 nuits ou plus ! R\u00e9servez en toute tranquillit\u00e9, votre s\u00e9jour est modifiable et annulable sans frais.",
        "price": "\u00a3441",
        "priceCent": "45",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation soumise \u00e0 conditions",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "LSTAY2",
        "oldPrice": "\u00a3490.50",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a349.05 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - LSTAY2-DR"
          }
        }
      },
      {
        "id": "RA3AD4",
        "title": "TARIF PREPAYE - SPECIAL LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez de notre meilleur tarif !",
        "price": "\u00a3613",
        "priceCent": "87",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RA3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RA3AD4"
          }
        }
      },
      {
        "id": "1RA1-DR",
        "title": "TARIF FLEXIBLE",
        "subTitle": "B\u00e9n\u00e9ficiez de l\u0027offre la plus flexible, un tarif modifiable et annulable sans frais.",
        "price": "\u00a3633",
        "priceCent": "73",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "07 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RA1",
        "oldPrice": "\u00a3704.15",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a370.41 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RA1-DR"
          }
        }
      },
      {
        "id": "RB3AD4",
        "title": "TARIF BED \u0026 BREAKFAST PREPAYE - LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027 \u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez du meilleur prix sur votre h\u00e9bergement avec petit d\u00e9jeuner \u00e0 prix r\u00e9duit.",
        "price": "\u00a3710",
        "priceCent": "16",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Non remboursable",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RB3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RB3AD4"
          }
        }
      },
      {
        "id": "1RB1",
        "title": "TARIF FLEXIBLE - CHAMBRE ET PETIT D\u00c9JEUNER",
        "subTitle": "Profitez de notre tarif le plus flexible, petit d\u00e9jeuner compris. Aucun frais de modification ou d\u0027annulation.",
        "price": "\u00a3800",
        "priceCent": "44",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "06 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RB1",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RB1"
          }
        }
      }
    ],
    "filterString": "Pour 4 nuits | 2 adultes et enfants",
    "filterStringVariation": "4 nuits | starting from",
    "eventTracking": {
      "title": {
        "event": "GAevent",
        "eventCategory": "Booking funnel - Rates",
        "eventAction": "Rates - Click on CTA",
        "eventLabel": "Select room - AR4P"
      }
    }
  },
  {
    "id": "AR4B",
    "selection": "Choose this apartment",
    "selectionActive": "Selected apartment",
    "title": "Appartement 1 pi\u00e8ce pour 4 personnes  -  Vue sur la Tour Eiffel.",
    "features": {
      "people": "x4",
      "area": "47m2"
    },
    "from": "A partir de",
    "availableText": "",
    "images": [],
    "firstImage": [],
    "price": "\u00a3503",
    "priceCent": "74",
    "oldPrice": "\u00a3559.71",
    "popup": {
      "fullDescription": "Vivez votre exp\u00e9rience parisienne dans cet appartement avec chambre s\u00e9par\u00e9e offrant une vue imprenable sur la Tour Eiffel.  La cuisine est tout \u00e9quip\u00e9e (avec lave-vaisselle) pour pr\u00e9parer de bons repas en toute autonomie.",
      "images": []
    },
    "discount": "Tarif membre -10%",
    "roomRates": [
      {
        "id": "LSTAY2-DR",
        "title": "TARIF FLEXIBLE SPECIAL- LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -45% en restant 28 nuits ou plus ! R\u00e9servez en toute tranquillit\u00e9, votre s\u00e9jour est modifiable et annulable sans frais.",
        "price": "\u00a3503",
        "priceCent": "74",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation soumise \u00e0 conditions",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "LSTAY2",
        "oldPrice": "\u00a3559.71",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a355.97 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - LSTAY2-DR"
          }
        }
      },
      {
        "id": "RA3AD4",
        "title": "TARIF PREPAYE - SPECIAL LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez de notre meilleur tarif !",
        "price": "\u00a3698",
        "priceCent": "13",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RA3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RA3AD4"
          }
        }
      },
      {
        "id": "1RA1-DR",
        "title": "TARIF FLEXIBLE",
        "subTitle": "B\u00e9n\u00e9ficiez de l\u0027offre la plus flexible, un tarif modifiable et annulable sans frais.",
        "price": "\u00a3723",
        "priceCent": "10",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "07 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RA1",
        "oldPrice": "\u00a3803.45",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a380.34 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RA1-DR"
          }
        }
      },
      {
        "id": "RB3AD4",
        "title": "TARIF BED \u0026 BREAKFAST PREPAYE - LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027 \u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez du meilleur prix sur votre h\u00e9bergement avec petit d\u00e9jeuner \u00e0 prix r\u00e9duit.",
        "price": "\u00a3794",
        "priceCent": "42",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Non remboursable",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RB3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RB3AD4"
          }
        }
      },
      {
        "id": "1RB1",
        "title": "TARIF FLEXIBLE - CHAMBRE ET PETIT D\u00c9JEUNER",
        "subTitle": "Profitez de notre tarif le plus flexible, petit d\u00e9jeuner compris. Aucun frais de modification ou d\u0027annulation.",
        "price": "\u00a3899",
        "priceCent": "74",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "06 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RB1",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RB1"
          }
        }
      }
    ],
    "filterString": "Pour 4 nuits | 2 adultes et enfants",
    "filterStringVariation": "4 nuits | starting from",
    "eventTracking": {
      "title": {
        "event": "GAevent",
        "eventCategory": "Booking funnel - Rates",
        "eventAction": "Rates - Click on CTA",
        "eventLabel": "Select room - AR4B"
      }
    }
  },
  {
    "id": "AS6P",
    "selection": "Choose this apartment",
    "selectionActive": "Selected apartment",
    "title": "Appartement 2 Chambres pour 6 personnes",
    "features": {
      "people": "x6",
      "area": "75m2"
    },
    "from": "A partir de",
    "availableText": "",
    "images": [],
    "firstImage": {
      "title": "Appartement 2 Chambres pour 6 personnes",
      "src": "https:\/\/medias.adagio-city.com\/photos\/6790_roas6p_00_p_346x260.jpg?twic=v1\/cover=307x230",
      "width": "307",
      "height": "230"
    },
    "price": "\u00a3723",
    "priceCent": "10",
    "oldPrice": "\u00a3803.45",
    "popup": {
      "fullDescription": "S\u00e9jour avec 1 canap\u00e9 lit double, chambre avec 1 lit double, chambre avec 2 lits simples, cuisine \u00e9quip\u00e9e, 2 salles de bain avec baignoire, WC, t\u00e9l\u00e9vision, t\u00e9l\u00e9phone, coffre-fort individuel, climatisation, wifi fibre optique, s\u00e9che cheveux.",
      "images": [
        {
          "title": "Appartement 2 Chambres pour 6 personnes",
          "src": "https:\/\/medias.adagio-city.com\/photos\/6790_roas6p_00_p_1024x768.jpg?twic=v1\/cover=720x540",
          "width": "720",
          "height": "540"
        }
      ]
    },
    "discount": "Tarif membre -10%",
    "roomRates": [
      {
        "id": "LSTAY2-DR",
        "title": "TARIF FLEXIBLE SPECIAL- LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -45% en restant 28 nuits ou plus ! R\u00e9servez en toute tranquillit\u00e9, votre s\u00e9jour est modifiable et annulable sans frais.",
        "price": "\u00a3723",
        "priceCent": "10",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation soumise \u00e0 conditions",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "LSTAY2",
        "oldPrice": "\u00a3803.45",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a380.34 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - LSTAY2-DR"
          }
        }
      },
      {
        "id": "RA3AD4",
        "title": "TARIF PREPAYE - SPECIAL LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027\u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez de notre meilleur tarif !",
        "price": "\u00a3999",
        "priceCent": "05",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RA3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RA3AD4"
          }
        }
      },
      {
        "id": "1RA1-DR",
        "title": "TARIF FLEXIBLE",
        "subTitle": "B\u00e9n\u00e9ficiez de l\u0027offre la plus flexible, un tarif modifiable et annulable sans frais.",
        "price": "\u00a31034",
        "priceCent": "55",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "07 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner non inclus",
            "highlighted": false,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RA1",
        "oldPrice": "\u00a31149.50",
        "saving": "\u003Ca href=\u0022#create-account\u0022 class=\u0022create-account\u0022\u003EBecome a member and save \u00a3114.95 on your reservation. Membership is free.\u003C\/a\u003E",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RA1-DR"
          }
        }
      },
      {
        "id": "RB3AD4",
        "title": "TARIF BED \u0026 BREAKFAST PREPAYE - LONG SEJOUR",
        "subTitle": "Economisez jusqu\u0027 \u00e0 -35% en restant 4 nuits ou plus ! Pr\u00e9payez votre s\u00e9jour et b\u00e9n\u00e9ficiez du meilleur prix sur votre h\u00e9bergement avec petit d\u00e9jeuner \u00e0 prix r\u00e9duit.",
        "price": "\u00a31095",
        "priceCent": "34",
        "features": [
          {
            "title": "Paiement en ligne",
            "highlighted": false,
            "icon": "icon-CARD"
          },
          {
            "title": "Non remboursable",
            "highlighted": false,
            "cancellation_date": "",
            "cancellation_label": "",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "RB3AD4",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - RB3AD4"
          }
        }
      },
      {
        "id": "1RB1",
        "title": "TARIF FLEXIBLE - CHAMBRE ET PETIT D\u00c9JEUNER",
        "subTitle": "Profitez de notre tarif le plus flexible, petit d\u00e9jeuner compris. Aucun frais de modification ou d\u0027annulation.",
        "price": "\u00a31245",
        "priceCent": "80",
        "features": [
          {
            "title": "Paiement \u00e0 l\u2019aparthotel",
            "highlighted": true,
            "icon": "icon-CARD"
          },
          {
            "title": "Annulation gratuite",
            "highlighted": true,
            "cancellation_date": "06 jan 12:00",
            "cancellation_label": "Annulation gratuite until",
            "icon": "icon-CLOCK"
          },
          {
            "title": "Petit-d\u00e9jeuner inclus",
            "highlighted": true,
            "icon": "icon-BREAKFAST"
          }
        ],
        "content": "TVA incluse. Taxes non incluses : \u00a317.33",
        "backRolledId": "1RB1",
        "eventTracking": {
          "title": {
            "event": "GAevent",
            "eventCategory": "Booking funnel - Rates",
            "eventAction": "Rates - Click on CTA",
            "eventLabel": "Select rate level - 1RB1"
          }
        }
      }
    ],
    "filterString": "Pour 4 nuits | 2 adultes et enfants",
    "filterStringVariation": "4 nuits | starting from",
    "eventTracking": {
      "title": {
        "event": "GAevent",
        "eventCategory": "Booking funnel - Rates",
        "eventAction": "Rates - Click on CTA",
        "eventLabel": "Select room - AS6P"
      }
    }
  }
]
const options = getOptions()
export default {
  "prefilledData": {
    "optionId": [options[1]?.id],
    "roomId": rooms[1]?.id,
    "roomRateId": rooms[1]?.roomRates[1]?.id
  },
  "result": rooms,
  "dataLayer": {
    "event": "push_dynamic_datas",
    "dynamic_datas_ready": true,
    "currencycode": "EUR",
    "jsessionid": "sSel1M2LQM7YVW0tUtiLbfr4Cc0C3My0XYzDSJtdTz1UkMP7",
    "isbooker": false,
    "countrymarket": "fr",
    "clienttype": "ANONYMOUS",
    "uilogged": false,
    "loyaltycardtypes": [],
    "searchcriteriaarrivaldate": "08-01-2024",
    "searchcriterianumbernights": "4",
    "searchcriteriadeparturedate": "12-01-2024",
    "searchcriterianumberrooms": 1,
    "searchcriterianumberadult": 2,
    "searchcriterianumberchildren": 0,
    "searchcriteriadestination": "6790",
    "pagepath": "\/fr\/booking\/rates",
    "hotelbrandcode": "ADG",
    "hotelbrandname": "ADAGIO ORIGINAL",
    "hotelcode": "6790",
    "hotelname": "Aparthotel Adagio Paris Centre Tour Eiffel",
    "hotelcurrencycode": "EUR",
    "hotelcitycode": "75015",
    "hotelcityname": "PARIS",
    "hotelcountrycode": "FR",
    "hotelcountryname": "France",
    "hotelamenities": "breakfast | coffee_machine | iron | kitchen | meeting_rooms | non_smoking | pool | privative_bathroom | wheelchair_access | wifi | laundry | parking"
  }
}
